import { Environment } from '@libs/order-process/shared/types';

export const environment: Environment = {
  production: true,
  envName: 'production',
  storagePrefix: 'api-order-process',
  apiUrl: '/api',
  wordpressBaseUrl: 'https://glucura.de/',
  languages: ['de', 'en', 'fr'],
  defaultLanguage: 'de',
};
